export default "__VITE_ASSET__CMN7upt0__"